export default __webpack_public_path__ + "static/media/waves-white.eac3c807.svg";